import React from 'react';
import styled, {css, CSSObject} from 'styled-components';

interface DivProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  margin?: string;
  padding?: string;
  width?: string;
  customStyles?: React.CSSProperties;
  maxWidth?: string | number;
  zIndex?: string;
  className?: string;
}

export const StyledDiv = styled.div<DivProps>`
  margin: ${(props) => props.margin || '0'};
  padding: ${(props) => props.padding || '0'};
  width: ${(props) => props.width || ''};
  max-width: ${(props) => props.maxWidth || ''};
  z-index: ${(props) => props.zIndex || ''};

  ${(props) => props.customStyles && css(props.customStyles as CSSObject)};
`;

const Div = React.forwardRef<HTMLDivElement, DivProps>(
  (
    {
      children,
      margin,
      padding,
      width,
      maxWidth,
      customStyles,
      zIndex,
      className,
      id,
    },
    ref,
  ) => {
    return (
      <StyledDiv
        ref={ref}
        width={width}
        margin={margin}
        padding={padding}
        maxWidth={maxWidth}
        zIndex={zIndex}
        customStyles={customStyles}
        className={className}
        id={id}
      >
        {children}
      </StyledDiv>
    );
  },
);

Div.displayName = 'StyledDivContainer';

export default Div;
